import { render, staticRenderFns } from "./brokerage.vue?vue&type=template&id=66805cbc&scoped=true&"
import script from "./brokerage.vue?vue&type=script&lang=js&"
export * from "./brokerage.vue?vue&type=script&lang=js&"
import style0 from "./brokerage.vue?vue&type=style&index=0&id=66805cbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66805cbc",
  null
  
)

export default component.exports